import { TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { Grid } from '@material-ui/core';
import { PessoaJuridicaAutocomplete } from 'app/main/pessoa';
import pessoaApi from 'app/services/api/pessoaApi';
import { useFormikContext } from 'formik';
import React from 'react';

function DadosGeraisTab({ papel, fetchPapel }) {
  const { values, errors, touched, ...formik } = useFormikContext();

  return (
    <Grid container spacing={3} className="mt-10">
      <Grid item xs={12} sm={12}>
        <TextInput
          autoFocus
          required
          label="Nome"
          id="pessoa.nome"
          value={values?.pessoa?.nome}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          maxLength={100}
          touched={touched?.pessoa?.nome}
          error={errors?.pessoa?.nome}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <PessoaJuridicaAutocomplete
          required
          label="CNPJ"
          id="pessoa.pessoaJuridica.cnpj"
          value={values?.pessoa}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={errors?.pessoa?.pessoaJuridica?.cnpj}
          touched={touched?.pessoa?.pessoaJuridica?.cnpj}
          fetchData={pessoaApi.buscarPessoaJuridica}
          papel={papel}
          fetchPapel={fetchPapel}
          permiteEditar
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectInput
          label="Indicador de inscrição estadual"
          id="pessoa.pessoaJuridica.indicadorInscricaoEstadual"
          onChange={formik.handleChange}
          value={values?.pessoa?.pessoaJuridica?.indicadorInscricaoEstadual}
          options={[
            { id: 'CONTRIBUINTE', title: 'Contribuinte de ICMS' },
            { id: 'NAO_CONTRIBUINTE', title: 'Não contribuinte de ICMS' },
            { id: 'CONTRIBUINTE_ISENTO', title: 'Contribuinte isento' },
          ]}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextInput
          label="Inscrição estadual"
          id="pessoa.pessoaJuridica.inscricaoEstadual"
          value={values?.pessoa?.pessoaJuridica?.inscricaoEstadual}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={errors?.pessoa?.pessoaJuridica?.inscricaoEstadual}
          touched={formik.submitCount > 0 || touched?.pessoa?.pessoaJuridica?.inscricaoEstadual}
          maxLength={20}
          replace={{ searchValue: /[^0-9]/gm, newValue: '' }}
          pattern={/^[0-9]*$/gm}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextInput
          label="Inscrição municipal"
          id="pessoa.inscricaoMunicipal"
          value={values?.pessoa?.inscricaoMunicipal}
          error={errors?.pessoa?.inscricaoMunicipal}
          touched={formik.submitCount > 0 || touched?.pessoa?.inscricaoMunicipal}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          maxLength={20}
        />
      </Grid>
    </Grid>
  );
}

export default DadosGeraisTab;
